// /login — the member entry screen: a depth-1 wire over the module-owned form
// (Law F1; @erp/module-auth/fe/sign-in carries the opaque-denial discipline,
// the step-up branch and the human check). A member reaches here by choosing
// "Sign in" on the public landing or by being bounced from a gated /account
// route; only the OPAC-flavoured copy lives here.
import { LogIn } from "lucide-solid";
import { SignInScreen } from "@erp/module-auth/fe/sign-in";

export function LoginScreen() {
  return (
    <SignInScreen
      title="Library sign in"
      subtitle="Sign in to see your loans, holds and fines."
      emailHint="The address on your library membership — the same one overdue notices go to."
      passwordHint="Case-sensitive. Sign-in failures never say which factor was wrong; ask the desk for a reset if both look right."
      icon={LogIn}
    />
  );
}
